<template>
  <div class="top-search flex-grow-1 d-flex align-self-center">
    <label class="ml-25 mb-0 align-self-center" for="top-search">
      <i class="far fa-search"></i>
    </label>
    <b-form-input
      type="text"
      placeholder="Recherche par référence unique"
      id="top-search"
      ref="top_search"
      class="flex-grow-1 border-0"
      v-model="keyword"
      @keyup.esc="keyword = null"
      @keyup.down="resultsDown"
      @keyup.up="resultsUp"
      @keyup.enter="navigate"
    ></b-form-input>
    <div
      v-if="results.length || isBusy"
      class="top-search-results-overlay"
      @click="keyword = null"
    ></div>
    <div v-if="results.length || isBusy" ref="top_search_results" class="top-search-results">
      <p v-if="isBusy" class="m-3">Chargement...</p>
      <ul
        v-if="results"
        class="list-group"
        @keyup.esc="keyword = null"
        @keyup.down="resultsDown"
        @keyup.up="resultsUp"
      >
        <li
          v-for="(result, index) in results"
          :key="index"
          :data-index="index"
          class="list-group-item"
          @mouseover="setSelectedResult(index)"
          @click="navigate"
        >
          <router-link :to="{ name: 'ReferenceDetail', params: { id: result.id } }"
            >{{ result.product.name }} - {{ result.internal_code }} ({{
              result.brand.toUpperCase()
            }}
            {{ result.model }})</router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "TopSearch",
  data() {
    return {
      keyword: null,
      results: [],
      isBusy: false,
      firstTopSearch: true,
    };
  },
  watch: {
    /**
     * Quand le mot clé change
     */
    keyword: _.debounce(function (newkeyword) {
      this.results = [];
      if (newkeyword) {
        this.isBusy = true;

        this.$http
          .get(process.env.BACK_API_URL + "reference", {
            params: {
              limit: 10,
              search: newkeyword,
            },
          })
          .then((response) => {
            this.isBusy = false;
            this.results = response.data.references;
          });
      }
    }, 500),
  },
  methods: {
    /**
     * Quand on appuis sur la flèche du bas, alors que le focus est dans le champ ou la liste
     * On sélectionne le résultat suivant
     */
    resultsDown() {
      if (this.results.length) {
        let index = 0;
        const allResults = this.$refs.top_search_results.querySelectorAll("li");
        const currectSelectedResult = this.$refs.top_search_results.querySelector("li.selected");

        // Si il y a déjà un résultat sélectionné, on récupère son index
        if (currectSelectedResult) {
          const currectSelectedResultIndex = parseInt(
            currectSelectedResult.getAttribute("data-index")
          );

          // Si le résultat sélectionné n'est pas le dernier, on incrémente l'index
          if (currectSelectedResultIndex < allResults.length - 1) {
            index = currectSelectedResultIndex + 1;
          }
        }

        this.setSelectedResult(index);
      }
    },
    /**
     * Quand on appuis sur la flèche du haut, alors que le focus est dans le champ ou la liste
     * On sélectionne le résultat précédent
     */
    resultsUp() {
      if (this.results.length) {
        const allResults = this.$refs.top_search_results.querySelectorAll("li");
        let index = allResults.length - 1;
        const currectSelectedResult = this.$refs.top_search_results.querySelector("li.selected");

        // Si il y a déjà un résultat sélectionné, on récupère son index
        if (currectSelectedResult) {
          const currectSelectedResultIndex = parseInt(
            currectSelectedResult.getAttribute("data-index")
          );

          // Si le résultat sélectionné n'est pas le premier, on décrémente l'index
          if (currectSelectedResultIndex > 0) {
            index = currectSelectedResultIndex - 1;
          }
        }

        this.setSelectedResult(index);
      }
    },
    /**
     * Sélectionne un résultat dans la liste
     * @param {integer}   index   Index du résultat dans la liste
     */
    setSelectedResult(index = 0) {
      const currectSelectedResult = this.$refs.top_search_results.querySelector("li.selected");

      // Si il y a déjà un résultat sélectionné, on le désélectionne
      if (currectSelectedResult) {
        currectSelectedResult.classList.remove("selected");
      }

      // Sélection du nouveau résultat
      this.$refs.top_search_results.querySelectorAll("li")[index].classList.add("selected");
    },
    /**
     * Lance la navigation sur un résultat en simulant le clic sur son lien
     */
    navigate() {
      const currectSelectedResult = this.$refs.top_search_results.querySelector("li.selected");

      // Si un résultat est actuellement sélectionné, on simule le clic sur son lien
      if (currectSelectedResult) {
        currectSelectedResult.querySelector("a").click();

        // Sinon on simule le clic sur le lien du premier résultat (et on le sélectionne)
      } else {
        this.setSelectedResult(0);
        this.$refs.top_search_results.querySelector("li").querySelector("a").click();
      }

      // On remet le focus dans le champ, sinon à cause du clic le focus est perdu
      // et la navigation par les flèche ne se fait plus
      this.$refs.top_search.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.top-search {
  position: relative;
  color: $text-50p;
  font-size: 12px;
  input.form-control {
    color: $text-50p;
    @extend .clanprobook;
    &::placeholder {
      color: $text-50p;
    }
  }
}
.top-search-results-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  width: 100%;
  height: 100%;
}
.top-search-results {
  position: absolute;
  top: 35px;
  left: 40px;
  background-color: white;
  z-index: 3001;
  width: calc(100% - 40px);
  li {
    cursor: pointer;
    &.selected {
      background-color: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/TopSearch.vue